export default __webpack_public_path__ + "static/media/calendar.a11776d2.svg";